import { cacheDom } from '../utils/QuerySelectors.js'
import { setupQuickAdds } from '../components/QuickAdd.js'
import { privatePrices } from '../utils/helpers.js'

const dom = {}
const qs = {
  slider: 'data-recommendations-slider',
}
const qsAll = {
  sections: 'data-section-type="product-recommendations"',
  quickAdds: 'data-product-quickadd',
}

const initSlider = (section) => {
  const sliderWrapper = section.querySelector(`[${qs.slider}]`)
  if (sliderWrapper) {
    new Swiper(sliderWrapper, {
      speed: 300,
      spaceBetween: 16,
      slidesPerGroup: 4,
      slidesPerView: 4,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      breakpoints: {
        320: {
          slidesPerGroup: 2,
          slidesPerView: 2,
        },
        768: {
          slidesPerGroup: 3,
          slidesPerView: 3,
        },
        1024: {
          slidesPerGroup: 4,
          slidesPerView: 4,
        },
      },
    })
    privatePrices()
  }
}

const initSection = (section) => {
  const useAPI = section.getAttribute('data-use-api')

  if (useAPI == 'true') {
    fetch(
      `${window.Shopify.routes.root}recommendations/products?product_id=${section.dataset.product}&limit=${section.dataset.limit}&section_id=${section.getAttribute('data-section-id')}&intent=related`,
    )
      .then((response) => response.text())
      .then((text) => {
        const recommendations = new DOMParser()
          .parseFromString(text, 'text/html')
          .querySelector('.recommendations').innerHTML
        if (recommendations && recommendations.trim().length > 0) {
          section.innerHTML = recommendations
          initSlider(section)
          if (section.getAttribute('data-quickadd') == 'true') {
            section.querySelectorAll(`[${qsAll.quickAdds}]`).forEach((quickAdd) => quickAdd.classList.add('!flex'))
            setupQuickAdds(section)
          }
          if (typeof window._swat === 'undefined') {
            console.warn('SWAT is not loaded, skipping wishlist initialization')
            return
          }

          window._swat.initializeActionButtons('#MainContent', '.plp-wishlist-btn')
        }
      })
  } else {
    initSlider(section)
    if (section.getAttribute('data-quickadd') == 'true') {
      section.querySelectorAll(`[${qsAll.quickAdds}]`).forEach((quickAdd) => quickAdd.classList.add('!flex'))
      setupQuickAdds(section)
    }
  }
}

export const setupProductRecommendations = () => {
  cacheDom(dom, qs, qsAll)
  dom.sections.forEach((section) => initSection(section))
}
